export default class Contacto  {
    NombreContacto:string = "" 
    Correo:string = "" 
    Telefono:string = "" 
    Asunto:string = "" 
    Mensaje:string = "" 
    FechaRegistro = ""
    Cedula:string =""
  }